module.exports = __webpack_public_path__ + "media/organizations/Zalando-36f0a919.webp";